// hooks/useRegattaSocket.js
import { useEffect, useState } from "react";
import io from "socket.io-client";

export const useRegattaSocket = (regattaID = "r15388") => {
  const [data, setData] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Connect to the server
    const socket = io("http://localhost:5003");

    socket.on("connect", () => {
      console.log("Connected to server");
      setIsConnected(true);

      // Subscribe to the regatta
      socket.emit("subscribe_regatta", regattaID);
    });

    // Listen for subscription confirmation
    socket.on("subscribed", (response) => {
      console.log("Subscribed:", response);
    });

    // Listen for data updates
    socket.on(`regatta_${regattaID}`, (payload) => {
      console.log("Data updated:", payload);
      setData(payload.data);
    });

    // Listen for errors
    socket.on(`regatta_${regattaID}_error`, (errorData) => {
      console.error("Firebase error:", errorData);
      setError(errorData.message);
    });

    socket.on("disconnect", () => {
      console.log("Disconnected from server");
      setIsConnected(false);
    });

    // Cleanup on unmount
    return () => {
      socket.emit("unsubscribe_regatta", regattaID);
      socket.disconnect();
    };
  }, [regattaID]);

  return { data, isConnected, error };
};
